<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { navigateToLoginSignupPage } from "~/utils/loginSignup/loginSignup"
import { PasswordForgetProps } from "./PasswordForget.props"
import { customPaths } from "~/utils/constants"

const props = withDefaults(defineProps<PasswordForgetProps>(), {
  hasItemsWithDefaultWidhts: true,
  emitOnEdit: false
})

const { emailFromCookies } = useLoginOrSignupCheckedEmail()

const emailField = ref(emailFromCookies.value)

const emit =
  defineEmits<{
    (e: "onPasswordForget", email: string): void
    (e: "onEditEmail"): void
  }>()

const { t } = useI18n()

const handlePasswordForget = (email: string | undefined | null) => {
  if (!email) {
    return
  }

  emit("onPasswordForget", email)
}

const handleEditEmail = () => {
  if (props.emitOnEdit) {
    emit("onEditEmail")
  } else {
    navigateToLoginSignupPage()
  }
}

const itemsWidthsClass = [
  props.hasItemsWithDefaultWidhts ? "md:w-[344px] lg:w-[424px]" : "w-full"
]
</script>

<template>
  <div class="p-4 text-start">
    
<FormKitLazyProvider config-file="true">
<p class="hyppo-bold md:elephant-bold mb-2 md:mb-6">
      {{ t("organism.cart.modals.login.forgetPassword") }}
    </p>

    <p class="beaver text-black-80 mb-4">
      {{ t("organism.cart.modals.login.recoverPassword") }}
    </p>

    <FormKit
      type="form"
      id="passwordForgetForm"
      :actions="false"
      form-class="flex w-full flex-col gap-4 md:items-center"
      :incomplete-message="false"
      @submit="() => handlePasswordForget(emailField)"
    >
      <TextfieldsEmail
        name="email"
        :loqate-check="false"
        v-model="emailField"
        :label="t('loginSignup.emailField')"
        :class="itemsWidthsClass"
        :disabled="!!emailFromCookies"
        @on-edit="handleEditEmail"
      />

      <UtilsButton
        type="submit"
        class="h-10 w-full"
        :text="t('myAccount.editPassword.send')"
      />
    </FormKit>

    <div class="my-8 flex justify-center gap-10">
      <UtilsButton
        class="
          custom-btn-no-padding
          custom-btn
          custom-btn-underline
          custom-btn-mouse-medium
        "
        theme="link-green"
        :text="t('organism.cart.modals.login.termAndCondition')"
        :path="customPaths.termsAndConditions"
      />
      <UtilsButton
        class="
          custom-btn-no-padding
          custom-btn
          custom-btn-underline
          custom-btn-mouse-medium
        "
        theme="link-green"
        :text="t('organism.cart.modals.login.privacy')"
        :path="customPaths.privacy"
      />
    </div>
</FormKitLazyProvider>

  </div>
</template>
